import { render, staticRenderFns } from "./DtEmpty.vue?vue&type=template&id=a09e4238&scoped=true"
import script from "./DtEmpty.vue?vue&type=script&lang=ts"
export * from "./DtEmpty.vue?vue&type=script&lang=ts"
import style0 from "./DtEmpty.vue?vue&type=style&index=0&id=a09e4238&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09e4238",
  null
  
)

export default component.exports